import { render, staticRenderFns } from "./LearnPageSearch.vue?vue&type=template&id=88f3b4b8"
import script from "./LearnPageSearch.vue?vue&type=script&lang=js"
export * from "./LearnPageSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports